export default "__VITE_ASSET__BuLcUNlr__"